import React, { Fragment, useState } from "react";

import { bool, func, number, object, oneOfType, string } from "prop-types";

import { ContactTelephone, DOB, Header, ManualAddress, Names } from "../Edit";

import { TextFieldGroup, Button } from "../../../common";

import MobileTelephone from "../Contacts/MobileTelephone";
import DateError from "../NamesAndDOB/DateError";

import * as style from "./styles.module.scss";
import history from "../../../history";
import { excludedUmbracoBranches } from "../../../helpers/helpers";

const BasicInfoEdit = ({
  appData,
  title,
  firstName,
  lastName,
  email,
  handleChange,
  birthDay,
  birthMonth,
  birthYear,
  onDobChange,
  hasDobChanged,
  validation,
  homeTelephone,
  mobileTelephone,
  onTelephoneChange,
  itemsChanged,
  description,
  branches: umbracoBranches,
  branchCode,
  loading,
  onSubmit,
  ...props
}) => {
  const isValid = (item) =>
    !itemsChanged[item] || validation[item] === undefined;

  const hasInvalidPhoneNumber = ["homeTelephone", "mobileTelephone"]
    .map((item) => isValid(item))
    .includes(false);

  const isDobInvalid = hasDobChanged && !!validation.birthYear;
  const isUnder16 =
    isDobInvalid && validation.birthYear[0] === "Birth year not before";
  const dobValidationMessage =
    (isDobInvalid &&
      isUnder16 &&
      "You must be 16 years old and above to register.") ||
    (isDobInvalid && !isUnder16 && "Please select a valid date") ||
    "";

  const hasInvalidItem = hasInvalidPhoneNumber || isDobInvalid;

  const [hasAttemptedEmailChange, setHasAttemptedEmailChange] = useState(false);

  const branches = umbracoBranches.filter(
    (branch) => !excludedUmbracoBranches.includes(branch.code)
  );

  return (
    <Fragment>
      <div className={style.container}>
        <h2 className="section-header">My details</h2>
        <div className={style.container__form_container}>
          <div className={style.container__form}>
            <div className="row">
              <Names
                memberTitle={title}
                memberFirstName={firstName}
                memberLastName={lastName}
                handleChange={handleChange}
                titleClasses={`${style.container__form_group} col-6`}
                firstNameClasses={`${style.container__form_group} col-12`}
                lastNameClasses={`${style.container__form_group} col-12`}
              />
            </div>
            <div className="row no-gutters">
              <DOB
                dayOfBirth={birthDay}
                monthOfBirth={birthMonth}
                yearOfBirth={birthYear}
                handleChange={onDobChange}
                isInvalid={isDobInvalid}
                oneRowOnMobile={true}
                classes={style.container__form_group}
              />
              {isDobInvalid ? (
                <DateError
                  id="date_error"
                  isRed={true}
                  errorMessage={dobValidationMessage}
                />
              ) : (
                <span />
              )}
            </div>
            <div className="row">
              <div className="form-group col-12 col-sm-8 col-md-12">
                <label htmlFor="email">Email address</label>
                <TextFieldGroup
                  inputId="email"
                  classes="register_field bg-transparent"
                  value={email}
                  onChange={() => setHasAttemptedEmailChange(true)}
                  validationMessageIsRed={true}
                  validationMessages={
                    hasAttemptedEmailChange
                      ? [
                          <div className="mt-1" key="error">
                            Please contact customer success team to update your
                            email address.
                          </div>,
                        ]
                      : undefined
                  }
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <ContactTelephone
                  title="Home phone number"
                  number={homeTelephone}
                  valueName="homeTelephone"
                  handleChange={onTelephoneChange}
                  validation={
                    itemsChanged.homeTelephone
                      ? validation.homeTelephone
                      : undefined
                  }
                  classes={`col-5 ${style.container__form_group}`}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <MobileTelephone
                  handleChange={onTelephoneChange}
                  mobileTelephone={mobileTelephone}
                  validation={
                    itemsChanged.mobileTelephone
                      ? validation.mobileTelephone
                      : undefined
                  }
                  classes={`col-5 ${style.container__form_group}`}
                />
              </div>
            </div>
            <ManualAddress
              handleChange={handleChange}
              {...props}
              classes={style.container__form_group}
            />
          </div>
          <div className="w-100 d-flex justify-content-end flex-column-reverse flex-sm-row">
            <Button
              styles={{ margin: "5px", minWidth: "175px !important" }}
              classes={`btn btn-outline-dark ${style.btn_backToMyAccount} `}
              onClick={() => history.push("/profile")}
            >
              Back to My Account
            </Button>
            <Button
              id="btnBasicInfoEditSubmit"
              classes="btn btn-primary"
              onClick={onSubmit}
              disabled={hasInvalidItem}
              styles={{ margin: "5px" }}
            >
              {" "}
              {loading ? "Loading..." : "Save"}
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const numberOrString = oneOfType([string, number]);

BasicInfoEdit.propTypes = {
  appData: object.isRequired,
  title: string.isRequired,
  firstName: string.isRequired,
  lastName: string.isRequired,
  email: string.isRequired,
  handleChange: func.isRequired,
  birthDay: numberOrString.isRequired,
  birthMonth: numberOrString.isRequired,
  birthYear: numberOrString.isRequired,
  onDobChange: func.isRequired,
  hasDobChanged: bool.isRequired,
  validation: object,
  homeTelephone: string.isRequired,
  mobileTelephone: string.isRequired,
  onTelephoneChange: func.isRequired,
  itemsChanged: object.isRequired,
  description: string.isRequired,
  branchCode: string.isRequired,
  loading: bool.isRequired,
  onSubmit: func.isRequired,
  agreesToMailshot: bool.isRequired,
};

export default BasicInfoEdit;
